<div data-aos1="fade-up-right">
    <img class="cross-icn" [src]="baseURL + 'cross-icon.png'">
</div>

<div class="part4">
    <div class="content">

        <div>
            <label class="txt-1" data-aos="fade-up">
                בואו לשחק יחד טריוויה מרחוק
            </label>

            <p class="txt-2" data-aos="fade-up">
                גלו עולם שלם ומלהיב, חוויה חדשנית שעוד לא הכרתם!
                <br>
                משחק טריוויה משותף, בטכנולוגיה יחודית ופורצת דרך:
                <br>
                כל אחד - מכל מקום - בכל מכשיר: ווב/אפליקציה/טלפון
            </p>
        </div>

        <div class="table-div" data-aos="fade-up">
            <div class="row titles-div m-0">
                <div *ngFor="let sec of sections; let i = index" (click)="currentSection = i" class="col-3 title"
                    [ngClass]="{'title-selected': currentSection === i}">{{sections[i].title}}</div>
            </div>
            <div class="table-content">
                <img class="section-content" [src]="baseURL + sections[currentSection].img" data-aos="fade-left">
            </div>
            <img class="in-develope" *ngIf="sections[currentSection].inDevelope" [src]="baseURL + 'in-develope.png'"
                data-aos="fade-up">
        </div>
    </div>
</div>